import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import { setAutoFreeze } from 'immer';
import { DesignSystemProvider, token } from '@bynder/design-system';
import { LocalizationProvider } from '@bynder/localization';
import { createGlobalStyle } from 'styled-components';
import { initSentry } from './initSentry';
import App from 'packages/pages/App';
import store from 'packages/store';
import initServerConnector from 'packages/initServerConnector';
import { checkPlatformUsage } from 'packages/store/platform/platform.actions';
import fetchFallback from 'packages/helpers/localization';

import './serviceWorker';
import './styles/inter.css';
import './styles/index.css';
import 'requestidlecallback-polyfill';

const GlobalVideoStyle = createGlobalStyle`
    .video-js:hover .vjs-big-play-button,
    .video-js .vjs-big-play-button:focus,
    .video-js .vjs-big-play-button:active {
        background-color: ${token.brandPrimary500} !important;
    }

    .video-js .vjs-loading-spinner {
        border-color: ${token.brandPrimary500} !important;
    }

    .video-js .vjs-play-progress,
    .video-js .vjs-volume-level {
        background-color: ${token.brandPrimary500} !important;
    }

    [role="listbox"], [role="menu"] {
        overscroll-behavior: none;
    }
`;

if (Intl?.PluralRules?.prototype?.select) {
    const originalSelect = Intl.PluralRules.prototype.select;

    Intl.PluralRules.prototype.select = function (value) {
        if (value === 0) {
            return 'zero';
        }

        return originalSelect.call(this, value);
    };
}

if (window !== window.parent) {
    initSentry();
    store.dispatch(checkPlatformUsage());
    initServerConnector();
    setAutoFreeze(false);

    ReactDOM.createRoot(document.querySelector('#root')).render(
        <DesignSystemProvider>
            <GlobalVideoStyle />
            <LocalizationProvider fetchFallback={fetchFallback} project="creative-studio-frontend" forceFallback>
                <Provider key="provider" store={store}>
                    <Router>
                        <Suspense fallback={null}>
                            <Routes>
                                <Route path="*" element={<App />} />
                            </Routes>
                        </Suspense>
                    </Router>
                </Provider>
            </LocalizationProvider>
        </DesignSystemProvider>,
    );
}
